import React from 'react';
import { 
    Container, 
    Box, 
    Typography,
    Divider,
    Button
} from '@material-ui/core';
import './Policy.css';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { Link } from 'react-router-dom';

export default function CookiePolicy() {
    const systemShortName = "AMO";
    const systemFullName = "Advanced Military Operations";

    const handleClickLink = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
    return (
        <Container className="containerPolicy">
            <Box className="boxPolicy">
                <Box className="boxPolicyDetail">
                    {/* <Box display="flex">
                        <Link to="/" className="textHref">
                            <Box display="flex" flexDirection="row">
                                <ArrowBackIosIcon />
                                <Box fontSize={16}>กลับ</Box>
                            </Box>
                        </Link>
                    </Box> */}
                    <Box textAlign="center" className="boxTitlePolicy">
                        <Box component="h5" className="titlePolicy">นโยบายคุกกี้ (Cookies Policy)</Box>
                        <Box component="h5" className="titlePolicy">ระบบ {systemFullName} (ระบบ {systemShortName})</Box>
                        <Box component="h5" className="titlePolicy">จัดทำเมื่อวันที่ 1 พฤษภาคม 2565 (version: 010565)</Box>
                    </Box>
                    <Divider className="hrFade"/>
                    <Box pt={3} pb={2}>
                        <Box className="contentPolicy"> 
                            เพื่อให้เป็นไปตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 บริษัท คลิกเกอร์แล็บ จำกัด ได้จัดทำนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ขึ้น เพื่อคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการทุกท่าน (Personal Information) ที่ติดต่อเข้ามายัง ระบบ {systemFullName} ต่อไปในนโยบายนี้เรียกว่า “ระบบฯ” ดังนี้ 
                        </Box>
                    </Box>
                    <Box py={2}>
                        <Typography variant='h6' className="listPolicy">1. นโยบายคุกกี้ </Typography>
                        <Box className="contentPolicy">
                            เมื่อท่านได้เข้าสู่ระบบฯ ข้อมูลที่เกี่ยวข้องกับการเข้าสู่เว็บไซต์ ของท่านจะถูกบันทึกไว้ในรูปแบบของคุกกี้ โดยนโยบายคุกกี้นี้จะอธิบายถึงความหมาย การทำงาน วัตถุประสงค์ รวมถึงการลบและการปฏิเสธการเก็บคุกกี้ เพื่อความเป็นส่วนตัวของท่าน โดยการเข้าสู่เว็บไซต์นี้ถือว่าท่านได้อนุญาตให้เราใช้คุกกี้ตามนโยบายคุกกี้ที่มีรายละเอียดดังต่อไปนี้ 
                        </Box>

                    </Box>
                    <Box py={2}>
                        <Typography variant='h6' className="listPolicy">2. คุกกี้คืออะไร </Typography>
                        <Box className="contentPolicy">
                            คุกกี้ คือ ไฟล์เล็ก ๆ เพื่อจัดเก็บข้อมูลการเข้าใช้งานเว็บไซต์ เช่น วันเวลา ลิงค์ที่คลิก หน้าที่เข้าชม เงื่อนไขการตั้งค่าต่าง ๆ โดยจะบันทึกลงไปในอุปกรณ์คอมพิวเตอร์ และ/หรือ เครื่องมือสื่อสารที่เข้าใช้งานของท่าน เช่น โน๊ตบุ๊ค แท็บเล็ต หรือ สมาร์ทโฟน ผ่านทางเว็บเบราว์เซอร์ในขณะที่ท่านเข้าสู่เว็บไซต์ โดยคุกกี้จะไม่ก่อให้เกิดอันตรายต่ออุปกรณ์คอมพิวเตอร์ และ/หรือ เครื่องมือสื่อสารของท่าน ในกรณีดังต่อไปนี้ ข้อมูลส่วนบุคคลของท่านอาจถูกจัดเก็บเพื่อใช้เพิ่มประสบการณ์การใช้งานบริการทางออนไลน์ โดยจะจำเอกลักษณ์ของภาษาและปรับแต่งข้อมูลการใช้งานตามความต้องการของท่าน เป็นการยืนยันคุณลักษณะเฉพาะตัว ข้อมูลความปลอดภัยของท่าน รวมถึงบริการที่ท่านสนใจ นอกจากนี้คุกกี้ยังถูกใช้เพื่อวัดปริมาณการเข้าใช้งานบริการทางออนไลน์ การปรับเปลี่ยนเนื้อหาตามการใช้งานของท่านโดยพิจารณาจากพฤติกรรมการเข้าใช้งานครั้งก่อน ๆ และ ณ ปัจจุบัน และอาจมีวัตถุประสงค์เพื่อการโฆษณาประชาสัมพันธ์ 
                        </Box>
                        <Box className="contentPolicy">
                            ทั้งนี้ท่านสามารถค้นหาข้อมูลเพิ่มเติมเกี่ยวกับคุกกี้ได้ที่ 
                            <Button className="textHref" onClick={() => handleClickLink("https://www.allaboutcookies.org")}> www.allaboutcookies.org </Button>
                        </Box>
                    </Box>
                    <Box py={2}>
                        <Typography variant='h6' className="listPolicy">3. เราใช้คุกกี้อย่างไร</Typography>
                        <Box className="contentPolicy">
                            เราใช้คุกกี้เพื่อเพิ่มประสบการณ์และความพึงพอใจของท่าน โดยจะทำให้เราเข้าใจลักษณะการใช้งานเว็บไซต์ของท่านได้เร็ว และทำให้เว็บไซต์ของเราเข้าถึงได้ง่าย สะดวกยิ่งขึ้น บางกรณีเราจำเป็นต้องให้บุคคลที่สามดำเนินการ ซึ่งอาจจะต้องใช้ อินเตอร์เน็ตโปรโตคอลแอดเดรส (IP Address) และคุกกี้เพื่อวิเคราะห์ทางสถิติ ตลอดจนเชื่อมโยงข้อมูล และประมวลผลตามวัตถุประสงค์ทางการตลาด
                        </Box>

                    </Box>
                    <Box py={2}>
                        <Typography variant='h6' className="listPolicy">4. ท่านจะจัดการคุกกี้ได้อย่างไร </Typography>
                        <Box className="contentPolicy">
                            หากท่านต้องการปฏิเสธการใช้ Cookies หรือ Session ท่านสามารถเลือกปฏิเสธการใช้งานได้ตอนเข้าระบบครั้งแรก หรือหากท่านเคยให้ความยินยอมในการใช้ แต่ต้องการยกเลิกและปฏิเสธการใช้งาน Cookie ในภายภาคหลัง ท่านสามารถ ติดต่อกับคณะทำงาน PDPA (ผู้ควบคุมข้อมูลส่วนบุคคล และ เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล) ของระบบฯ ตามที่อยู่ที่ปรากฏข้างล่างนี้ แต่ทว่าหากท่านปฏิเสธการใช้งาน Cookie ท่านอาจจจะไม่สามารถใช้งานระบบฯได้บางส่วน หรือทั้งหมด
                        </Box>
                    </Box>
                    <Box pt={2} pb={3}>
                        <Typography variant='h6' className="listPolicy">5. การปฏิบัติตามนโยบายคุ้มครองข้อมูลส่วนบุคคลและการติดต่อ</Typography>
                        <Box className="contentPolicy">
                            ในกรณีที่ท่านมีข้อสงสัย ข้อเสนอแนะ หรือข้อติชมใด ๆ เกี่ยวกับนโยบายการคุ้มครองข้อมูลส่วนบุคคล หรือการ ปฏิบัติตามนโยบายการคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ ระบบฯ ยินดีที่จะตอบข้อสงสัย รับฟังข้อเสนอแนะ และคำติชมทั้งหลาย อันจะเป็นประโยชน์ต่อการปรับปรุงการให้บริการของระบบฯ ต่อไป โดยท่านสามารถ ติดต่อกับคณะทำงาน PDPA (ผู้ควบคุมข้อมูลส่วนบุคคล และ เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล) ของระบบฯ ตามที่อยู่ที่ปรากฏข้างล่างนี้ 
                        </Box>
                    </Box>
                    <Divider className="hrFade"/>
                    <Box py={3}>
                        <Box py={0.5}>ระบบ {systemFullName}</Box>
                        <Box py={0.5}>บริษัท คลิกเกอร์แล็บ จำกัด</Box>
                        <Box py={0.5}>คณะทำงาน PDPA (ผู้ควบคุมข้อมูลส่วนบุคคล และ เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล)</Box>
                        <Box py={0.5}>pdpa@klickerlab.com</Box>
                    </Box>
                </Box>
            </Box>
        </Container>
    )
}